var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSurveyAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4735 3.83496L34.5 26.3977L31.0265 32.4145H4.97353L1.5 26.3977L14.5265 3.83496H21.4735Z",
    fill: "#6F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSurveyAnalysis);
export default __webpack_public_path__ + "static/media/Ico_Survey Analysis.fb7356b06f8384f1f96eaa7029d2feff.svg";
export { ForwardRef as ReactComponent };